export default __webpack_public_path__ + "static/media/check_filled.164b5301.svg";